import type { ScreenModule } from "../../../app/screen-module";
import { BudgetPage } from "../pages";

export default {
	id: "tenant-admin.budget",
	path: "/admin/budget",
	area: "tenant-admin",
	navGroup: "管理",
	label: "予算・上限・利用量",
	roles: ["tenant_admin", "platform_admin"],
	backing: "MOCK_ONLY",
	enabled: true,
	component: BudgetPage,
} satisfies ScreenModule;
